module.exports = __webpack_public_path__ + "fonts/poppins-extrabold-webfont.3a914e10.woff2";